import translate from './translate';
import Interpolate from './interpolate';
import Trans from './trans';
import I18nextProvider from './I18nextProvider';
import loadNamespaces from './loadNamespaces';

export { loadNamespaces, translate, Interpolate, I18nextProvider, Trans };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-i18next/dist/es/index.js
// module id = 16
// module chunks = 0